<template>
	<div id="widgetAdvancedSearch" class="widgetAdvancedSearch">
		<h2 class="heading2">条件から探す</h2>

		<form v-on:submit.prevent="searchSubmit">
			<my-wasi v-bind:collapse="false" collapseid="widgetAdvancedSearchItem_9" v-if="isPageFlg">
				<template slot="heading">イメージ検索</template>
				<template slot="content">
					<ul class="imageSearchList">
						<li v-for="item in images" class="inputToggle inputToggle--type_img">
							<input v-model="checkedImage[item.id]" v-on:change="updateCheckboxIS" v-bind:name="item.id" v-bind:id="item.id" type="checkbox">
							<label v-bind:class="['inputToggle__label--' + item.id, {'checked': checkedImage[item.id]}]" v-bind:for="item.id">
								<img v-if="checkedImage[item.id]" v-bind:src="'/static/images/imageSearchBlock/' + item.btnonimage" v-bind:alt="item.name">
								<img v-else v-bind:src="'/static/images/imageSearchBlock/' + item.btnimage" v-bind:alt="item.name">
							</label>
						</li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi collapseid="widgetAdvancedSearchItem_0">
				<template slot="heading">撮影タイプ</template>
				<template slot="content">
					<ul class="toggleList">
						<li><input v-model="checked.sm" v-on:change="updateRadio" name="sm" type="radio" id="shootingType_still" value="0"><label v-bind:class="{'checked': checked.sm === 0}" for="shootingType_still">スチール</label></li>
						<li><input v-model="checked.sm" v-on:change="updateRadio" name="sm" type="radio" id="shootingType_movie" value="1"><label v-bind:class="{'checked': checked.sm === 1}" for="shootingType_movie">ムービー</label></li>
						<li><input v-model="checked.sm" v-on:change="updateRadio" name="sm" type="radio" id="shootingType_none" value="2"><label v-bind:class="{'checked': checked.sm === 2}" for="shootingType_none">指定なし</label></li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi anchor="as1" collapseid="widgetAdvancedSearchItem_1">
				<template slot="heading">スタジオのタイプ</template>
				<template slot="content">
					<ul class="toggleList">
						<li><input v-model="checked.p_st" v-on:change="updateRadio" name="p_st" type="radio" id="studioType_horizont" value="1"><label v-bind:class="{'checked': checked.p_st === 1}" for="studioType_horizont">ホリゾントスタジオ</label></li>
						<li><input v-model="checked.p_st" v-on:change="updateRadio" name="p_st" type="radio" id="studioType_house" value="2"><label v-bind:class="{'checked': checked.p_st === 2}" for="studioType_house">ハウススタジオ</label></li>
						<li><input v-model="checked.p_st" v-on:change="updateRadio" name="p_st" type="radio" id="studioType_none" value="0"><label v-bind:class="{'checked': checked.p_st === 0}" for="studioType_none">指定なし</label></li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi anchor="as2" collapseid="widgetAdvancedSearchItem_2">
				<template slot="heading">スタジオ面の広さ・高さ</template>
				<template slot="content">
					<h4 class="widgetAdvancedSearchItems__heading2">面積：</h4>
					<div class="sliderBox">
						<input v-model="sliderValue.area" v-bind="splitSliderValue(sliderValue.area, 'ssm')" type="text" name="ssm" class="studio_area" :value="">
					</div>

					<ul class="toggleList">
						<li v-for="item in sliderValueBtn.area">
							<input v-model="sliderValue.area" v-on:change="splitSliderValue(item.value, 'ssm')" type="radio" id="{{item.id}}" name="ssmBtn" class="js-studio_area_update" value="{{item.value}}"><label v-bind:class="{'checked': sliderValue.area === item.value}" for="{{item.id}}">{{item.label}}</label>
						</li>
					</ul>

					<h4 class="widgetAdvancedSearchItems__heading2">高さ：</h4>
					<div class="sliderBox">
						<input v-model="sliderValue.height" v-bind="splitSliderValue(sliderValue.height, 'ssh')" type="text" class="studio_height" name="ssh" :value="">
					</div>

					<ul class="toggleList">
						<li v-for="item in sliderValueBtn.height">
							<input v-model="sliderValue.height" v-on:change="splitSliderValue(item.value, 'ssh')" type="radio" id="{{item.id}}" name="sshBtn" class="js-studio_height_update" value="{{item.value}}"><label v-bind:class="{'checked': sliderValue.height === item.value}" for="{{item.id}}">{{item.label}}</label>
						</li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi collapseid="widgetAdvancedSearchItem_3">
				<template slot="heading">料金</template>
				<template slot="content">
					<h4 class="widgetAdvancedSearchItems__heading2">1時間：</h4>
					<div class="sliderBox">
						<input v-model="sliderValue.price" v-bind="splitSliderValue(sliderValue.price, 'sp')" type="text" class="studio_price" name="sp" :value="">
					</div>

					<ul class="toggleList">
						<li v-for="item in sliderValueBtn.price">
							<input v-model="sliderValue.price" v-on:change="splitSliderValue(item.value, 'sp')" type="radio" id="{{item.id}}" name="spBtn" class="js-studio_price_update" value="{{item.value}}"><label v-bind:class="{'checked': sliderValue.price === item.value}" for="{{item.id}}">{{item.label}}</label>
						</li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi anchor="as3" collapseid="widgetAdvancedSearchItem_4">
				<template slot="heading">地域（東京都）</template>
				<template slot="content">
					<ul id="area_tokyo_checkBox" class="toggleList">
						<li v-for="item in district">
							<input v-model="checked[item.id]" v-on:change="updateCheckbox" v-bind:name="item.id" v-bind:id="item.id" type="checkbox" value="1"><label v-bind:class="{'checked': checked[item.id]}" v-bind:for="item.id">{{item.name}}</label>
						</li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi collapseid="widgetAdvancedSearchItem_5">
				<template slot="heading">地域</template>
				<template slot="content">
					<ul class="toggleList">
						<li v-for="code in areaCode">
							<input v-model="checked['sa' + code]" v-on:change="updateCheckbox" name="sa{{code}}" id="sa{{code}}" type="checkbox" value="1"><label v-bind:class="{'checked': checked['sa' + code]}" for="sa{{code}}">{{ getPrefectures(code) }}</label>
						</li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi anchor="as4" collapseid="widgetAdvancedSearchItem_6">
				<template slot="heading">被写体・シチュエーション</template>
				<template slot="content">
					<ul class="toggleList">
						<li v-for="item in situation">
							<input v-model="checked[item.id]" v-on:change="updateCheckbox" v-bind:name="item.id" v-bind:id="item.id" type="checkbox"><label v-bind:class="{'checked': checked[item.id]}" v-bind:for="item.id">{{item.name}}</label>
						</li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi collapseid="widgetAdvancedSearchItem_7">
				<template slot="heading">撮影設備・備品</template>
				<template slot="content">
					<ul class="toggleList">
						<li v-for="item in facility">
							<input v-model="checked[item.id]" v-on:change="updateCheckbox" v-bind:name="item.id" v-bind:id="item.id" type="checkbox"><label v-bind:class="{'checked': checked[item.id]}" v-bind:for="item.id">{{item.name}}</label>
						</li>
					</ul>
				</template>
			</my-wasi>

			<my-wasi collapseid="widgetAdvancedSearchItem_8">
				<template slot="heading">諸サービス</template>
				<template slot="content">
					<ul class="toggleList">
						<li v-for="item in service">
							<input v-model="checked[item.id]" v-on:change="updateCheckbox" v-bind:name="item.id" v-bind:id="item.id" type="checkbox"><label v-bind:class="{'checked': checked[item.id]}" v-bind:for="item.id">{{item.name}}</label>
						</li>
					</ul>
				</template>
			</my-wasi>

			<div class="widgetAdvancedSearch__footer text-center">
				<template v-if="isPageFlg">
					<button v-if="xsflg" v-on:click.prevent="searchSubmit" v-on:click="smoothScroll('body')" class="btn btn_submit">検 索</button>
					<button v-else v-on:click.prevent="searchSubmit" v-on:click="smoothScroll('body')" class="btn btn_submit">検 索</button>
				</template>
				<template v-else>
					<button v-on:click.prevent="searchSubmit" class="btn btn_submit">検 索</button>
				</template>
				<button v-on:click.prevent="conditionReset" v-on:click="resetSlider" class="btn btn_clear">全選択条件クリア</button>
			</div>

		</form>
	</div>
</template>

<script>
import { searchWords, searchConditions, radio, checkbox, areacode, SCStr, imageSearch, checkboxImageSearch, reset } from '../vuex/actions';
import { getSearchWords, getSearchConditions, getChecked, getSliderValue, getPrefecturesList, getDistrict, getAreaCode, getSituation, getFacility, getService, getSliderValueBtn, getImage, getCheckedImage } from '../vuex/getters';
import { defaultSliderValue } from '../vuex/default_values';
module.exports = {
	vuex: {
		getters: {
			w: getSearchWords,
			c: getSearchConditions,
			checked: getChecked,
			checkedImage: getCheckedImage,
			sliderValue: getSliderValue,
			prefecturesList: getPrefecturesList,
			district: getDistrict,
			areaCode: getAreaCode,
			situation: getSituation,
			facility: getFacility,
			service: getService,
			sliderValueBtn: getSliderValueBtn,
			images: getImage
		},
		actions: {
			updateSearchWords: searchWords,
			updateSearchConditions: searchConditions,
			updateRadio: radio,
			updateCheckbox: checkbox,
			setAreaCode: areacode,
			setSCStr: SCStr,
			updateImage: imageSearch,
			updateCheckboxIS: checkboxImageSearch,
			conditionReset: reset
		}
	},
	props: {
		xsflg: '',
		collapse: {
			type: Boolean
		}
	},
	data: function(){
		return {
			sliderObj: {
				area: {},
				height: '',
				price: ''
			}
		};
	},
	created: function(){
		this.getHasResultsArea();
		// console.log(this.$root.prefectures);
	},
	ready: function(){
		// ion.RangeSlider
		// 面積
		var $studio_area = $('.studio_area');
		var $studio_area_update = $('.js-studio_area_update');
		$studio_area.ionRangeSlider({
			hide_min_max: true,
			keyboard: true,
			min: 0,
			max: 300,
			from: this.checked.ssmu,
			to: this.checked.ssmo,
			type: 'double',
			step: 10,
			postfix: '&#13217;',
			grid: true,
			grid_num: 6,
			max_postfix: '+'
		});
		// this.sliderObj.area = $studio_area.data('ionRangeSlider');
		var slider_area = $studio_area.data('ionRangeSlider');

		$studio_area_update.on('click', function(){
			var array = splitValue($(this).val());
			slider_area.update({
				from: Number(array[0]),
				to: Number(array[1])
			});
		});

		// 高さ
		var $studio_height = $('.studio_height');
		var $studio_height_update = $('.js-studio_height_update');
		$studio_height.ionRangeSlider({
			hide_min_max: true,
			keyboard: true,
			min: 0,
			max: 10,
			from: this.checked.sshu,
			to: this.checked.ssho,
			type: 'double',
			step: 1,
			postfix: 'm',
			grid: true,
			grid_num: 5,
			max_postfix: '+'
		});
		// this.sliderObj.height = $studio_height.data('ionRangeSlider');
		var slider_height = $studio_height.data('ionRangeSlider');

		$studio_height_update.on('click', function(){
			var array = splitValue($(this).val());
			slider_height.update({
				from: Number(array[0]),
				to: Number(array[1])
			});
		});

		// 料金
		var $studio_price = $('.studio_price');
		var $studio_price_update = $('.js-studio_price_update');
		$studio_price.ionRangeSlider({
			hide_min_max: true,
			keyboard: true,
			min: 0,
			max: 50000,
			from: this.checked.spu,
			to: this.checked.spo,
			type: 'double',
			step: 5000,
			postfix: '円',
			grid: true,
			grid_num: 10,
			max_postfix: '+'
		});
		this.sliderObj.price = $studio_price.data('ionRangeSlider');
		var slider_price = $studio_price.data('ionRangeSlider');

		$studio_price_update.on('click', function(){
			var array = splitValue($(this).val());
			slider_price.update({
				from: Number(array[0]),
				to: Number(array[1])
			});
		});

		// splitValue
		function splitValue(value){
			return value.split(';');
		}
	},
	beforeDestroy: function(){
		// console.log('as beforeDestroy');
	},
	computed: {
		isPageFlg: function(){
			return this.$route.isPage;
		}
	},
	methods: {
		debug: function(){
			console.log(this.checked);
		},
		getHasResultsArea: function(){
			var devmode = this.$route.devmode;
			var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
			var hostname = document.location.hostname;
			var apipath = host + '//' + hostname + '/s/api/';
			var url = devmode ? '/static/json/sample_area_code.json' : apipath + 'area_code';
			this.$http.get(url).then(function (response) {
				// console.log(response.data);
				// this.$set('areaCode', response.data);
				this.setAreaCode(response.data);
			}, function (response) {
				// error callback
				console.log(response.status);
				this.message = 'データの取得に失敗しました';
			});
		},
		splitSliderValue: function(value, name){
			if (value){
				var array = value.split(';');
				var pathU = 'checked.' + name + 'u';
				var pathO = 'checked.' + name + 'o';
				this.$set(pathU, Number(array[0]));
				this.$set(pathO, Number(array[1]));
				// this.checked[name + 'u'] = array[0];
				// this.checked[name + 'o'] = array[1];
				// console.log(value + ' | ' + name + 'u:' + array[0] + '/' + name + 'o:' + array[1]);
			}
		},
		resetSlider: function(){
			// reset slider (input[text])
			var ds = defaultSliderValue();
			// this.$set('sliderValue', ds);
			for (var prop in ds){
				var dsProp = ds[prop].split(';');
				this.sliderObj[prop].update({
					from: dsProp[0],
					to: dsProp[1]
				});
			}
		}
	},
	components: {
		'my-wasi': require('./widget_advanced_search_items.vue')
	},
	mixins: [
		require('../mixins/getPrefectures.js'),
		require('../mixins/searchSubmit.js'),
		require('../mixins/smoothScroll.js')
	]
};
</script>

<style scoped lang="scss">
	.sliderBox{
		display: none;
	}
</style>



// WEBPACK FOOTER //
// widget_advanced_search.vue?42a1206c